<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <div
    class="current-time-indicator"
    :style="style"
  >
    <div class="dot"></div>
    <div class="dark-line"></div>
    <div class="thin-line"></div>
  </div>
</template>

<script setup>
import { DateTime } from 'luxon'
import { onBeforeUnmount, onMounted, ref } from 'vue'

onMounted(() => {
  updateCurrentTimeIndicator()
  setInterval(updateCurrentTimeIndicator, 1000 * 60)
})

onBeforeUnmount(() => {
  clearInterval(updateCurrentTimeIndicator)
})

const style = ref({ top: 0 })

function updateCurrentTimeIndicator () {
  const now = DateTime.now()
  const minutes = now.diff(now.startOf('day')).as('minutes')
  const top = minutes / 24 / 60
  style.value = { top: `${top * 100}%` }
}
</script>

<style lang="scss" scoped>
  .weekview-container .appointment-container .current-time-indicator .dark-line {
    left: 0;
    width: 100%;
  }

  .weekview-container .appointment-container .current-time-indicator .dot {
    left: -5px
  }
</style>
